import { createContext } from 'react';

import {
  FormControlGroupComponentContextData,
  FormControlGroupContextData,
} from './types';

export interface FormControlGroupContextType {
  contextData: FormControlGroupContextData;
  setFormControlContext: (contextData: FormControlGroupContextData) => void;
  setFormControlContextByComponent: (
    componentName: string,
    contextData: FormControlGroupComponentContextData
  ) => void;
}

export const FormControlGroupContext =
  createContext<FormControlGroupContextType>({
    contextData: {},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setFormControlContext: () => {},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setFormControlContextByComponent: () => {},
  });
